export const data = [
  {
    index: "1",
    name: "rsm-ecommerce",
    title: "full stack application",
    description: `This project fully dynamic. Every part of this website are dynamic, 
    I wanted to complete the full e-commerce functionality, Which I have completed this project.This application has professional design. Besides, it has products categories, products sorting, products comment, Multiple products buy and sell option, products searching,
     products rating, and it has also dynamic stripe payment system.The application Also has dynamic login system. A user can create his account with profile picture, also he can change his profile image, update his profile, if he wants he can change his password. Also,
      it has forgot password option.There are two dashboard option for user and admin. An account profile for the user, And also has for admin.n the user options, the user can do whatever is limited for the user. In the admin dashboard, Admin has full website control.
       Admin can change everything if he wants.Built the client-side & backend-side using HTML, CSS, ReactJS, React-Router, React Hook Form, React Router, Bootstrap, MongoDB, Redux, express JS and deployed on Heroku
 `,
    image: "https://i.ibb.co/q0dZBNT/screenshot-8.png",
    githubLink: "https://github.com/riazakhanda017ksn/fashion-mern-ecommerce",
    live: "http://mernstackprofessionaleccomerce.herokuapp.com/",
  },
  {
    index: "2",
    name: "shareme social media",
    title: "full stack application",
    description: `This is a social media photo sharing application. Where a user can upload pictures. Another user, a user, can comment. Moreover,
     all the pictures that the user will download will have a save option.And the pictures that he uploaded will have his profile. All user images will be uploaded in
      the form of categories. Moreover, the user has a personal profile. Built the client-side & backend-side using HTML, CSS, ReactJS, React Hook Form, React Router, Bootstrap, MongoDB, Sanity, and deployed on Firebase. 
    `,
    image: "https://i.ibb.co/HY1thS8/screenshot-58.png",
    githubLink:
      "https://github.com/riazakhanda017ksn/shareme-social-application-front-end",
    live: "https://sharemersm.web.app/",
  },
  {
    index: "3",
    name: "ema john",
    title: "full stack application",
    description: `This web application made for any products e-commerce site and this site is fully dynamic. 
    There is a user log in form system, products management, products add and delete and also have admin panel and also have  payment getaway system.
    uilt the client-side & backend-side using HTML, CSS, ReactJS, React-Router, React Hook Form, React Router, Bootstrap, MongoDB, Heroku, express JS and deployed on Firebase.
    `,
    image: "https://i.ibb.co/ZTC0qBM/screenshot-55.png",
    githubLink: "https://github.com/riazakhanda017ksn/ema-john-with-react",
    live: "https://web-of-xyz.web.app/",
  },
  {
    index: "4",
    name: "unrealistic photography",
    title: "full stack application",
    description: `This web application made for any products e-commerce site and this site is fully dynamic. There is a user log in form system, products management, products add and delete and also have admin panel.
    Built the client-side & backend-side using HTML, CSS, ReactJS, React-Router, React Hook Form, React Router, Bootstrap, MongoDB, Heroku, express JS and deployed on Firebase. 
    `,
    image: "https://i.ibb.co/cww7DsV/screenshot-57.png",
    githubLink: "https://github.com/riazakhanda017ksn/unrealistic-photography",
    live: "https://true-log-in-form.web.app/",
  },
  {
    index: "5",
    name: "Your it shop",
    title: "full stack application",
    description: `This web application made for any products e-commerce site and this site is fully dynamic.There is a user log in form system, products management, products add and delete and also have admin panel.
    Built the client-side & backend-side using HTML, CSS, ReactJS, React-Router, React Hook Form, React Router, Bootstrap, MongoDB, Heroku, express JS and deployed on Firebase.
    `,
    image: "https://i.ibb.co/Y0RPV12/screenshot-56.png",
    githubLink: "https://github.com/riazakhanda017ksn/Your-it-shop",
    live: "https://new-project-223bb.web.app/",
  },
];
